import { Component, EventEmitter, Output } from '@angular/core';
import * as screenfull from 'screenfull';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output()
  toggleSidenav = new EventEmitter<void>();
  @Output()
  toggleNotificationSidenav = new EventEmitter<void>();

  constructor(private router: Router) {
  }

  fullScreenToggle(): void {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('member');
    localStorage.clear();
    setTimeout(() => {
      this.router.navigate(['/public/login']);
    }, 1000);
  }
}
